module.exports = __webpack_public_path__ + "static/website01-be89c65f5b01fb1df9522cb15df9d881.jpg";